"use client"
import Text from "@/components/common/Typography/Text"
import { Card, Col, Popover, PopoverProps, Row } from "antd"
import { FC, memo, ReactNode, useRef, useState } from "react"

import InputSearch, { InputSearchRef } from "./InputSearch"
import SearchPlacementsResult from "./SearchPlacementsResult"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import PageDrawerMobile, { PageDrawerMobileRef } from "@/components/common/PageDrawerMobile"

type SelectPlacementProps = {
  label?: string,
  icon?: ReactNode,
  placeholder?: string,
  value?: any,
  onSearch?: (searchValue?: string) => void,
  onChange?: (valueObject?: any) => void,
  size?: 'small' | 'default',
  type?: 'destination' | 'departure',
  hasError?: boolean,
  popoverProps?: PopoverProps
}

const SelectPlacement: FC<SelectPlacementProps> = ({ size = 'default', type = 'destination', value, onChange, onSearch, hasError, popoverProps, ...props }) => {
  const [open, setOpen] = useState<boolean>(false)
  const isDesktop = useIsDesktop()
  const ref = useRef<HTMLDivElement>(null)
  const refInputSearch = useRef<InputSearchRef>(null)
  const refDrawer = useRef<PageDrawerMobileRef>(null)

  const content = (
    <Card
      ref={ref}
      size='small'
      variant='borderless'
      className={`home__searching--placement${hasError ? ' home__searching--placement--error' : ''}`}
      onClick={() => {
        if (isDesktop) {
          setOpen(true)
          return
        }
        refDrawer.current?.open()
      }}
    >
      <Row className="home__searching--input-label" align='middle' gutter={[5, 5]} wrap={false}>
        <Col>
          <Text>
            {props.icon}
          </Text>
        </Col>
        <Col>
          <Text>{props.label}</Text>
        </Col>
      </Row>
      <Row>
        <Col span={24} style={{ height: '2.3rem' }}>
          <InputSearch
            ref={refInputSearch}
            style={{ padding: 0 }}
            placeholder={props.placeholder}
            className={`home__searching--input home__searching--input-small`}
            variant='borderless'
            cardSize={size}
            value={value?.name}
            onSearch={onSearch}
            valueObject={value}
            allowClear
          />
        </Col>
      </Row>
    </Card>
  )

  if (!isDesktop) {
    return (
      <>
        <PageDrawerMobile
          ref={refDrawer}
          headerProps={{
            shownRight: false,
            title: (
              <InputSearch
                ref={refInputSearch}
                placeholder={props.placeholder}
                // cardSize={'default'}
                value={value?.name}
                onSearch={onSearch}
                valueObject={value}
                // allowClear
                size='middle'
              />
            )
          }}
        >
          <Col span={24}>
            <SearchPlacementsResult
              onChange={(value) => {
                onChange && onChange(value)
                setOpen(false)
                refDrawer.current?.close()
              }}
              type={type}
            />
          </Col>
        </PageDrawerMobile>
        {content}
      </>
    )
  }

  return (
    <Popover
      trigger={['click']}
      open={open}
      onOpenChange={(open) => setOpen(open)}
      arrow={false}
      placement='bottomLeft'
      {...popoverProps}
      styles={{
        ...(typeof popoverProps?.styles === 'function' ? undefined : popoverProps?.styles),
        content: {
          paddingBottom: '1.2rem',
          paddingInline: '0rem',
          paddingTop: 0,
          width: '75rem',
          overflow: 'auto',
          maxHeight: '50rem',
          overflowX: 'hidden',
          ...(typeof popoverProps?.styles === 'function' ? undefined : popoverProps?.styles?.content)
        }
      }}
      content={(
        <SearchPlacementsResult
          onChange={(value) => {
            onChange && onChange(value)
            setOpen(false)
          }}
          type={type}
        />)}
    >
      {content}
    </Popover>
  )
}

export default memo(SelectPlacement)